import type { Dish } from "@arfood/shared";
import { buildBody } from "./t0.ts";
import { actionButton, el, pickI18n } from "./util.ts";

export type ModelViewerElement = HTMLElement & {
  canActivateAR?: boolean;
  activateAR?: () => void;
};

export interface DishCardT1 {
  card: HTMLElement;
  modelViewer: ModelViewerElement;
}

// Konfiguriertes <model-viewer> (Inline-3D + native AR). Wird von Karte und Detail-Overlay genutzt.
export function createModelViewer(dish: Dish, name: string): ModelViewerElement {
  const mv = document.createElement("model-viewer") as ModelViewerElement;
  mv.className = "dish-media";
  if (dish.model.glb) mv.setAttribute("src", dish.model.glb);
  if (dish.model.usdz) mv.setAttribute("ios-src", dish.model.usdz);
  mv.setAttribute("alt", name);
  mv.setAttribute("ar", "");
  mv.setAttribute("ar-modes", "webxr scene-viewer quick-look");
  mv.setAttribute("ar-scale", "fixed"); // echte Portionsgröße
  mv.setAttribute("camera-controls", "");
  mv.setAttribute("touch-action", "pan-y");
  mv.setAttribute("shadow-intensity", "1");
  mv.setAttribute("loading", "lazy");
  mv.setAttribute("reveal", "auto");
  if (dish.model.poster) mv.setAttribute("poster", dish.model.poster);
  // Eigener (versteckter) ar-button-Slot unterdrückt model-viewers Default-Button;
  // AR wird über die Aktions-Buttons via activateAR() ausgelöst.
  const arSlot = document.createElement("button");
  arSlot.slot = "ar-button";
  arSlot.type = "button";
  arSlot.style.display = "none";
  mv.appendChild(arSlot);
  return mv;
}

// T1 — Inline-3D-Karte. „In AR ansehen" liegt in den Aktionen (ruft mv.activateAR()), nicht als Slot-Overlay.
export function createDishCardT1(dish: Dish, lang: string): DishCardT1 {
  const { name, desc } = pickI18n(dish, lang);

  const card = el("article", "dish-card dish-card--t1");
  card.dataset["tier"] = "T1";
  card.dataset["dish"] = dish.id;

  const wrap = el("div", "dish-media-wrap");
  const mv = createModelViewer(dish, name);
  const badge = el("span", "badge-3d");
  badge.textContent = "◆ 3D · 360°";
  wrap.append(mv, badge);

  const ar = actionButton("btn-primary", "ar", "In AR ansehen");
  const add = actionButton("btn-add", "order", "+");
  card.append(wrap, buildBody(name, desc, dish, lang, [ar, add]));
  return { card, modelViewer: mv };
}
